import { AxiosAgentBuilder, IApiClientConfiguration, IHttpAgent } from '@sparelabs/http-client-utils'
import { GeographyResource, TurnRuleResource, WayFilterResource, WayOverrideResource } from './resources'

export class GeographyClient {
  public geographies: GeographyResource

  private readonly agent: IHttpAgent

  constructor(agent: IHttpAgent) {
    this.agent = agent
    this.geographies = new GeographyResource(agent)
  }

  public wayFilters(geographyId: string): WayFilterResource {
    return new WayFilterResource(this.agent, geographyId)
  }

  public wayOverrides(geographyId: string): WayOverrideResource {
    return new WayOverrideResource(this.agent, geographyId)
  }

  public turnRules(geographyId: string): TurnRuleResource {
    return new TurnRuleResource(this.agent, geographyId)
  }

  public static build(configuration: IApiClientConfiguration): GeographyClient {
    return new GeographyClient(AxiosAgentBuilder.build(configuration))
  }
}
